import { render, staticRenderFns } from "./TabOrganizationInfo.view.vue?vue&type=template&id=558e87d7&"
import script from "./TabOrganizationInfo.view.vue?vue&type=script&lang=js&"
export * from "./TabOrganizationInfo.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('558e87d7')) {
      api.createRecord('558e87d7', component.options)
    } else {
      api.reload('558e87d7', component.options)
    }
    module.hot.accept("./TabOrganizationInfo.view.vue?vue&type=template&id=558e87d7&", function () {
      api.rerender('558e87d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/misc/TabOrganizationInfo.view.vue"
export default component.exports